// Translator notes: Phase 5 items 1, 5, 9: British spelling, phrasal and light verbs, our paraphrases (engine/src/phrase-rewrites.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  enSpelling: {
    args: ['pairs'],
    fi: (a: string[]) => `Brittiläinen kirjoitusasu luettiin amerikkalaisena: ${a[0]}.`,
    en: (a: string[]) => `British spelling was read as American: ${a[0]}.`,
  },
  phrasalVerb: {
    args: ['pairs'],
    fi: (a: string[]) => `Sanaliitto luettiin yhtenä verbinä, jolle sanakirjassa on valyriankielinen vastine: ${a[0]}.`,
    en: (a: string[]) => `A phrase was read as one verb the dictionary has a Valyrian word for: ${a[0]}.`,
  },
  paraphraseOurs: {
    args: ['pairs'],
    fi: (a: string[]) => `Kiertoilmaus (meidän): valyriassa ei ole sanaa, joten käännös tehtiin tutuista sanoista (${a[0]}). Ilmaus ei ole Petersonin.`,
    en: (a: string[]) => `Our paraphrase: Valyrian has no word for this, so it was translated with known words (${a[0]}). The wording is not Peterson's.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
